import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'
import moment from 'moment'

const service = new ApolloClientService()

var EXERCISE_ACTION_TYPE = {
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  ADD: 'ADD',
  CONNECT: 'CONNECT',
  DISCONNECT: 'DESCONNECT',
}

export default class Schedule {
  getExerciseArray = (regs) => {
    var exercises = []
    for (var i = 0; i < regs.length; i++) {
      var { _id, name, exerciseschedule } = regs[i]
      for (var j = 0; j < exerciseschedule.length; j++) {
        var exercise = exerciseschedule[j]
        exercises.push({
          ...exercise,
          _id: _.uniqueId('REGEXER'),
          regimen: {
            _id,
            name,
          },
        })
      }
    }
    return exercises
  }

  modifyExerciseArray = (exer, exers, type) => {
    var exercises = JSON.parse(JSON.stringify(exers))
    switch (type) {
      case EXERCISE_ACTION_TYPE.EDIT:
        exercises[_.findIndex(exers, { _id: exer._id })] = exer
        break
      case EXERCISE_ACTION_TYPE.DELETE:
        _.remove(exercises, { _id: exer._id })
        break
      case EXERCISE_ACTION_TYPE.ADD:
        exercises.push(exer)
        break
      default:
        console.log('no action type was selected or matched')
        break
    }
    return exercises
  }

  modifyAllExercises = (exers, input, surgeryDate, skipToAll=false) => {
    var exercises = JSON.parse(JSON.stringify(exers))
    exercises.forEach((i, index) => {
      if (
        moment()
          .startOf('day')
          .isAfter(moment(surgeryDate).add(i.startdate, 'd').startOf('day')) &&
        moment()
          .startOf('day')
          .isAfter(moment(surgeryDate).add(i.enddate, 'd').startOf('day'))
      )
        exercises[index] = i
      else exercises[index] = skipToAll ? { ...i, skiponsurgerydate: true } : { ...i, ...input }

    })

    return exercises
  }

  array_move = (arr, old_index, new_index) => {
    console.log(old_index, new_index)
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1
      while (k--) {
        arr.push(undefined)
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
    return arr
  }

  getConnectedArray = (exercises, exercise) => {
    if (!exercise.nextexerciseid) return [exercise._id]
    var connects = [],
      selectIndex = _.findIndex(exercises, { _id: exercise._id })
    for (var i = selectIndex; i < exercises.length; i++) {
      var { _id, nextexerciseid, ...rest } = exercises[i]
      if (
        (nextexerciseid && nextexerciseid == exercises[i + 1]?.exercise?._id) ||
        rest.exercise._id == exercises[i - 1]?.nextexerciseid
      )
        connects.push(_id)
      else break
    }
    return connects
  }

  getMovedExercises = ({ to = 0, array = [], idarray = [] }) => {
    var current = to
    for (var i = 0; i < idarray.length; i++) {
      array = this.array_move(
        array,
        _.findIndex(array, { _id: idarray[i] }),
        current
      )
      current++
    }
    return array
  }

  getInvertMovedExercises = ({ to = 0, array = [], idarray = [] }) => {
    for (var i = 0; i < idarray.length; i++)
      this.array_move(
        array,
        _.findIndex(array, { _id: idarray[i] }),
        to < 0 ? 0 : to
      )
    return array
  }

  getInvertConnectArray = (exercises, exercise, selectedIndex) => {
    if (!exercises[selectedIndex - 1]?.nextexerciseid)
      return [exercises[selectedIndex]._id]
    var connects = []
    for (var i = selectedIndex; i >= 0; i--) {
      var {
        exercise: { _id },
        ...rest
      } = exercises[i]
      var prev = exercises[i - 1]
      if (
        (prev?.nextexerciseid && prev?.nextexerciseid == _id) ||
        rest?.nextexerciseid == exercises[i + 1]?.exercise?._id
      )
        connects.push(rest?._id)
      else break
    }
    return connects
  }

  handleInvertSelect = (exercise, exercises, selectedIndex) => {
    var connectedArray = this.getInvertConnectArray(
      exercises,
      exercise,
      selectedIndex
    )
    exercises[selectedIndex].nextexerciseid = exercise.exercise._id
    exercises = this.getInvertMovedExercises({
      to: _.findIndex(exercises, { _id: exercise._id }),
      array: exercises,
      idarray: connectedArray,
    })
    console.log(exercises, connectedArray)
    return exercises
  }

  connectExercises = (exercise, selected, exers) => {
    var exercises = JSON.parse(JSON.stringify(exers))
    var connectedArray = this.getConnectedArray(exercises, exercise)
    var selectedIndex = _.findIndex(exercises, { _id: selected._id })
    if (selectedIndex > _.findIndex(exercises, { _id: exercise._id }))
      return this.handleInvertSelect(exercise, exercises, selectedIndex)
    exercises[selectedIndex].nextexerciseid = exercise.exercise._id
    exercises = this.getMovedExercises({
      to: selectedIndex + 1,
      array: exercises,
      idarray: connectedArray,
    })
    return exercises
  }

  disconnectExercise = (exercise, exers) => {
    var exercises = JSON.parse(JSON.stringify(exers))
    exercises[_.findIndex(exercises, { _id: exercise._id })].nextexerciseid =
      null
    return exercises
  }

  allowToSelect = (exercise, exers, selectedExer) => {
    var nextexerciseid =
      exers[_.findIndex(exers, { _id: exercise._id }) - 1]?.nextexerciseid
    if (nextexerciseid) return false
    var connectedArray = this.getConnectedArray(exers, exercise)
    return connectedArray[connectedArray.length - 1] != selectedExer._id
  }

  getSchedule = (patientid) => {
    return new Promise((resolve, reject) => {
      service
        .getSchedule(patientid)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  stripTypename = (value) => {
    if (Array.isArray(value)) return value.map(this.stripTypename)
    if (value && typeof value === 'object') {
      const out = {}
      for (const k of Object.keys(value)) {
        if (k === '__typename') continue
        out[k] = this.stripTypename(value[k])
      }
      return out
    }
    return value
  }

  // Normalize TracPatch rows so the schedule's HOLD/REPEAT fields and the
  // per-patient tracpatchConfigOverrides.requiredHoldSeconds/requiredReps
  // are always equal on save. Row-level edit handlers in exercise.conf.js
  // already enforce this, but the bottom SAVE button bypasses them when
  // the clinician types into the inline fields and saves without first
  // committing the row, so we reconcile one more time here as a safety net.
  syncTracpatchOverrides = (exercise) => {
    if (!exercise) return exercise
    var ex = exercise
    var isTracpatch =
      (ex.exercise && ex.exercise.type === 'TracPatch') ||
      (ex.meta && ex.meta.type === 'TracPatch') ||
      ex.type === 'TracPatch'
    if (!isTracpatch) return ex
    var overrides = Object.assign({}, ex.tracpatchConfigOverrides || {})
    // REPEAT → requiredReps
    var repeatNum = parseInt(ex.repeat, 10)
    if (repeatNum > 0) overrides.requiredReps = repeatNum
    // HOLD ("N seconds" / "N minutes") → requiredHoldSeconds
    if (ex.hold) {
      var holdStr = String(ex.hold)
      var holdN = parseInt(holdStr, 10)
      if (holdN > 0) {
        var isMin = /minute/i.test(holdStr)
        overrides.requiredHoldSeconds = isMin ? holdN * 60 : holdN
      }
    } else {
      delete overrides.requiredHoldSeconds
    }
    return Object.assign({}, ex, {
      tracpatchConfigOverrides:
        Object.keys(overrides).length > 0 ? overrides : null,
    })
  }

  // The schedule row's `exercise` is sent to the server as GraphQL `ExerciseIn`,
  // which has NO `surgeryTypes` field (it only accepts `surgeryTypeIds`). The
  // Exercise query/list returns the POPULATED `surgeryTypes` objects, so an
  // exercise added to a schedule carries that field and the editSchedule
  // mutation 400s with "Field surgeryTypes is not defined by type ExerciseIn".
  // Strip it before save — the schedule snapshot doesn't track surgery
  // associations (older exercises never had the field either).
  stripExerciseInputExtras = (row) => {
    if (!row || !row.exercise || typeof row.exercise !== 'object') return row
    if (!('surgeryTypes' in row.exercise)) return row
    const exercise = Object.assign({}, row.exercise)
    delete exercise.surgeryTypes
    return Object.assign({}, row, { exercise })
  }

  getFormatedExer = (exercises) =>
    exercises
      .map(this.syncTracpatchOverrides)
      .map(this.stripExerciseInputExtras)
      .map(this.stripTypename)

  editSchedule = ({ patient, exercises }) => {
    return new Promise((resolve, reject) => {
      service
        .editSchedule({ patient, exercises: this.getFormatedExer(exercises) })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
}

export { EXERCISE_ACTION_TYPE }
